import { useMutation, useQueryClient } from 'react-query';

import {
  saveUserBinder,
  type SaveUserBinderResponse,
  type UpdateUserBinderResponse
} from '../../services/userBindersService';
import { USER_BINDER_QUERY_KEYS } from '../queryKeys';

type SaveUserBinderVariables = {
  artistId: string;
  memberId: string;
  dataUrl: string;
  shouldUpdate?: boolean;
};

export function useSaveUserBinder() {
  const queryClient = useQueryClient();

  return useMutation<
    SaveUserBinderResponse | UpdateUserBinderResponse,
    Error,
    SaveUserBinderVariables
  >(
    ({ artistId, memberId, dataUrl, shouldUpdate }) =>
      saveUserBinder(artistId, memberId, dataUrl, shouldUpdate),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(USER_BINDER_QUERY_KEYS.all);
      }
    }
  );
}
